import { useSelector } from 'react-redux'
import type { Coupon as CouponType } from 'shared/types'
import { Coupon } from 'app/common/coupon'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import type { RootState } from 'shared/store/reducers'
import { SPACING } from 'app-v2/design-tokens'

type CouponsInfosProps = {
    restaurantId: string
}

export const CouponsInfos = ({ restaurantId }: CouponsInfosProps) => {
    const { coupons } = useSelector(
        (state: RootState) => state.restaurantPageState
    )

    return (
        <Coupons>
            {coupons.map((c: CouponType, index: number) => {
                const { id, hasCode, ...couponProps } = c
                return (
                    <CouponContainer key={index}>
                        <Coupon id={id} {...couponProps} />
                    </CouponContainer>
                )
            })}
        </Coupons>
    )
}

const Coupons = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const CouponContainer = styled.div`
    margin-top: ${SPACING.XS};
    margin-bottom: ${SPACING.XS};
    width: 100%;
    ${media.medium`
        width: calc(50% - ${SPACING.XS});
    `};
`
